import React from "react";
import { styles } from "../../Form";
import {
  CssTextFieldSignIn,
  CssButtonSignIn,
  CssLoginTitleTypography,
} from "../../styles/styled";
import Box from "@mui/material/Box";

function ConfirmSignUp(props) {
  let errorLabel = "";
  if (props.errMess !== "") {
    errorLabel = <label style={styles.errorLabel}>{props.errMess}</label>;
  }
  return (
    <div style={styles.signInContainer}>
      <Box
        style={{
          backgroundColor: "#26890d",
          position: "absolute",
          width: "480px",
          top: 0,
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      >
        <CssLoginTitleTypography>認証確認</CssLoginTitleTypography>
      </Box>
      <label style={styles.label}>認証コード</label>
      <CssTextFieldSignIn
        id="confirmSignUpCode"
        defaultValue=""
        size="small"
        name="confirmationCode"
        onChange={(e) => {
          e.persist();
          props.updateFormState(e);
        }}
      />
      {errorLabel}
      <CssButtonSignIn
        variant="contained"
        size="large"
        color="success"
        onClick={props.confirmSignUp}
      >
        ログイン
      </CssButtonSignIn>
    </div>
  );
}

export default ConfirmSignUp;
